.kdx-related-articles-widget {
    padding: 24px 0;
    
    .section-headline { margin: 0 0 24px 0; }
    .related-article {
        border-bottom: 1px solid #CECECE;        
        margin-bottom: 16px;

        &:last-child { border-bottom: none; }
        .article-title {            
            @include line-height(23);
        }
        .author-date {
            font-weight: 600;
            @include text-size(14);
            @include line-height(19);
            margin-bottom: 8px;

            .author + .date {
                border-left: 1px solid #C1C1C1;
                padding-left: 8px;
                margin-left: 8px;
            }
        }
        .desc {
            @include text-size(14);
            @include line-height(21);
        }
    }
}
